import { UPDATE_SCREEN } from '../Types';

// get initial state from window if possible
const initialState = {};

export const freeForm = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SCREEN:
      return {
        ...state,
        [action.screenName]: {
          content: action.content,
          isLoaded: true,
        },
      };
    default:
      return state;
  }
};
